/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentProcessingReceiptIntelligenceOutcome =
    (typeof DocumentProcessingReceiptIntelligenceOutcome)[keyof typeof DocumentProcessingReceiptIntelligenceOutcome];

export const DocumentProcessingReceiptIntelligenceOutcome = {
    Findings: 'Findings',
    NoFindings: 'NoFindings',
    Failed: 'Failed',
    NotRun: 'NotRun',
} as const;
